// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useContext } from 'react';
import { RouteProps } from 'react-router-dom';
import LoginLayout from '../../layouts/LoginLayout';
import LoginForm from './LoginForm';
import LogoImage from '../../assets/images/login-logo.svg'
import Center from '../../components/Center';
import S from './styles';
import { useIntl } from 'react-intl';
import MemberContext from '../../contexts/MemberContext';

// function getToken(hash: string) {
//   return hash
//     .split('&')
//     .map((chunk) => {
//       const split = chunk.split('=');
//       return {
//         [split[0].replace('#', '')]: split[1]
//       };
//     })
//     .reduce((pre, now) => ({ ...pre, ...now }), {});
// }

const LoginPage = (props: RouteProps): JSX.Element => {
  const member = useContext(MemberContext);
  const [loginNotAuth, setLoginNotAuth] = useState<string | undefined>();

  const intl = useIntl();

  const checkCognitoStatus = () => {
    let cognitoExist = false;
    const cognitoKey = localStorage.getItem('CognitoKey');
    if (cognitoKey) {
      const idToken = localStorage.getItem(`${cognitoKey}.idToken`)
      if (!idToken) {
        member.clear();
        localStorage.removeItem('CognitoKey');
      } else {
        const parseJwt = (token:string) => { return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()); }
        const exp = new Date(new Date(0).setUTCSeconds(parseJwt(idToken).exp));
        const now = new Date();
        if (exp.valueOf() > now.valueOf()) {
          cognitoExist = true;
        } else {
          cognitoExist = false;
        }
      }
    }
    return cognitoExist;
  }

  window.history.replaceState(null, '', window.location.pathname);

  return (
    <LoginLayout errorLogin={loginNotAuth}>
      <S.Container>
        <Center>
          <S.HeaderContainer>
            <S.Logo src={LogoImage} />
            <S.Title>{intl.formatMessage({ id: 'J001' })}</S.Title>
            <S.SubTitle>{intl.formatMessage({ id: 'J002' })}</S.SubTitle>
          </S.HeaderContainer>
        </Center>
        <S.LoginFormContainer>
          <LoginForm setLoginNotAuth={setLoginNotAuth} loginNotAuth={loginNotAuth} checkCognitoStatus={checkCognitoStatus}/>
        </S.LoginFormContainer>
      </S.Container>
    </LoginLayout>
  );
}
export { LoginPage as default }
